<!-- list (widget card, side column) or chips (one row on the dashboard, the last ones only) -->
<div #riListElt class="recent-items" [class.recent-items--chips]="variant === 'chips'">
  @if (rows$ | async; as allRows) {
    @let rows = variant === 'chips' ? allRows.slice(0, maxChips) : allRows;
    @for (row of rows; track row.item) {
      <div
        class="recent-item"
        role="button"
        tabindex="0"
        [title]="row.item.name"
        (click)="openTab($event, row.item)"
        (keydown.enter)="openTab($event, row.item)">
        <span class="recent-item-icon {{ row.icon }}" aria-hidden="true"></span>
        <span class="recent-item-label">
          @if (row.type) {
            <span class="recent-item-type">{{ row.type }}</span>
          }
          <span class="recent-item-ref">{{ row.ref }}</span>
        </span>
      </div>
    } @empty {
      <div class="recent-item recent-item--empty">{{ 'dashboard.noRecentItem' | translate }}</div>
    }
  } @else {
    <div class="recent-item recent-item--loading">Loading...</div>
  }
</div>
